<template>
  <div class="niste-clan">
    <div>{{ $t("not_part.project_text") }}</div>
    <router-link to="/projects">{{ $t("not_part.go_back") }}</router-link>
  </div>
</template>

<script>
export default {
    

}
</script>

<style>

</style>